import { LockOutlined } from '@ant-design/icons';

export const LockIcon = () => {
  return <LockOutlined style={{ cursor: 'pointer' }} />;
};
